import GroupForecaster from './GroupForecaster.vue';

export const groupForecasterRoutes = [
  { path: 'group-forecaster', name: 'group-forecaster', component: GroupForecaster }
];
